__turbopack_context__.v({
  "colors": "Track-module__jx4o-W__colors",
  "container": "Track-module__jx4o-W__container",
  "root": "Track-module__jx4o-W__root",
  "text": "Track-module__jx4o-W__text",
  "trackGraph": "Track-module__jx4o-W__trackGraph",
});
